import React from 'react';
interface DragHandleProps {
  onDragStart: (e: React.TouchEvent) => void;
  onDragMove: (e: React.TouchEvent) => void;
  onDragEnd: () => void;
}

export const DragHandle: React.FC<DragHandleProps> = ({
  onDragStart,
  onDragMove,
  onDragEnd,
}) => {
  return (
    <div 
      className="flex-shrink-0 flex flex-col items-center py-2 bg-white dark:bg-gray-800"
      onTouchStart={onDragStart}
      onTouchMove={onDragMove}
      onTouchEnd={onDragEnd}
      style={{ touchAction: 'none' }}
    >
      {/* iOS风格的拖动指示条 */}
      <div className="w-10 h-1 bg-gray-300 dark:bg-gray-600 rounded-full cursor-grab active:cursor-grabbing" />
    </div>
  );
};
